module.exports = __webpack_public_path__ + "static/media/video.b59cdd6b.mp4";